'use client';
var classes = {"root":"m_347db0ec","root--dot":"m_fbd81e3d","label":"m_5add502a","section":"m_91fdda9b"};

export { classes as default };
//# sourceMappingURL=Badge.module.css.mjs.map
